import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";
import styles from "./MisReportsGraphs.module.scss";
import { commonVaribles } from "src/constants/constVariables";

const PercentageReturnableGraph = ({ percentageData }) => {
  
  const [chartOptions, setChartOptions] = useState({});

  const getChartOptions = () => {
    return {
    title: {
      text: "Percentage of Returnable Packaging",
      left: "left",
      textStyle: {
        color: "#000000", // Set title text color to black
        fontWeight: "600",
        fontFamily: "OpensansRegular",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
				let tooltipText = `${params[0].axisValue}<br/>`; // Show the plant name (x-axis value)

				// Colors directly from series
				const returnableColor = '#46A46C'; 
				const expendableColor = '#7ACAF3'; 

				// Iterate over the series (Packaging and Transportation)
				params.forEach((param) => {
					let seriesColor;
					if (param.seriesName === 'Returnable Percentage') {
						seriesColor = returnableColor; 
					} else if (param.seriesName === 'Expendable Percentage') {
						seriesColor = expendableColor; 
					}

					// Add colored square for series name
					tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${seriesColor}"></span>`;
					// Adjusted spacing, now the value will appear aligned to the right
					tooltipText += `${param.seriesName}: <span style="float:right;">${param.value}</span><br/>`;
				});

        const returnableCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
				const returnableCount =
        percentageData?.returnable_count[returnableCountIndex];

				
				tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#F1B379"></span>`;
				tooltipText += `<strong>Returnable count: <span style="float:right;">${returnableCount?.toFixed(0)}</span></strong><br/>`;

			
				const otherCountIndex = params[0].dataIndex; // Use the dataIndex of the first param to find the index
				const otherCount =
        percentageData?.other_count[otherCountIndex]; 

				tooltipText += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#817AF3"></span>`;
				tooltipText += `<strong>Other count: <span style="float:right;">${otherCount?.toFixed(0)}</span></strong><br/>`;
        
				return tooltipText; // Return the complete tooltip text
			},
    },
    legend: {
      data: ["Returnable Percentage", "Expendable Percentage"],
      right: "1%",
      orient: "vertical",
    },
    xAxis: [
      {
        type: "category",
        data: percentageData?.header_array,
        splitLine: {
          show: false, // Hide the separation line along the x-axis
        },
        axisLabel: {
          width: 100,
          rotate: 40,
          interval: 0,
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          show: false, // Hide the grid lines on the y-axis
        },
        axisLine: {
          show: true, // Show y-axis line
        },
      },
    ],
    grid: {
      backgroundColor: "#FFFF00", // Set the background color of the grid
    },
    series: [
      {
        name: "Returnable Percentage",
        type: "bar",
        data: percentageData?.returnable_percentage,
        barGap: "50%", // Set the gap between bars
        barWidth: window.innerWidth <= 600 ? 15 : 30,
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#57DA65" },
              { offset: 0.5, color: "#51CC5D" },
              { offset: 1, color: "#46A46C" },
            ],
          },
          barBorderRadius: 10,
          borderWidth: 1,
        },
        label: {
          show: true, // Show label on top of the bar
          position: "top", // Position the label on top of the bar
          color: "black", // Label color
          fontSize: "12%", // Label font size
          formatter: function (params) {
            return `${params.value}%`;
          },
        },
      },
      {
        name: "Expendable Percentage",
        type: "bar",
        data: percentageData?.other_percentage,
        barWidth: window.innerWidth <= 600 ? 15 : 30,
        itemStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "#79D0F1" },
              { offset: 0.5, color: "#74B0FA" },
              { offset: 1, color: "#817AF3" },
            ],
          },
          barBorderRadius: 10,
          borderWidth: 1,
        },
        label: {
          show: true, // Show label on top of the bar
          position: "top", // Position the label on top of the bar
          color: "black", // Label color
          fontSize: "12%", // Label font size
          formatter: function (params) {
            return `${params.value}%`;
          },
        },
      },
    ],
  };
  };

  useEffect(() => {
      setChartOptions(getChartOptions());
  
      // Update chart options on window resize
      const handleResize = () => {
        setChartOptions(getChartOptions());
      };
  
      window.addEventListener('resize', handleResize);
  
      // Cleanup event listener on component unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
  }, [percentageData]);
  
  return (
    <>
      {percentageData.length !== 0 ? (
        <div className={styles.pieChartGraph}>
          <ReactECharts
            option={chartOptions}
            notMerge={true}
            className={styles["chart"]}
          />
        </div>
      ) : (
        <div className={styles.containers}>{commonVaribles.data_not_found}</div>
      )}
    </>
  );
};

export default PercentageReturnableGraph;
